import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import timeUp from '../../../assets/img/time-up-arro.svg';
import timeDown from '../../../assets/img/time-doun-arro.svg';
import { getDateFormat, isFutureDate, isTimeInPast, weeklyDaysOptions } from 'utils/Helpers';
import DatePicker from 'react-datepicker';
import appToast, { TOAST_TYPE } from 'utils/AppToast';
import { useStore } from 'hooks/useStore';

const RecurrenceForm = ({
  formData,
  setFormData,
  errors,
  setErrors,
  frequencyOptions,
  dateTypes,
  initialData,
  isEditing,
  projectIdFromParams,
  showleftPart = false
}) => {
  const [store] = useStore();
  const [dateType, setDateType] = useState(formData.dateType || 'ongoing');
  const [startDate, setStartDate] = useState(formData.recurrenceStartDate || null);
  const [recurrenceFrequency, setRecurrenceFrequency] = useState(formData.recurrenceFrequency || 'weekly');
  const [recurrenceCycleCount, setRecurrenceCycleCount] = useState(formData.recurrenceCycleCount || '');
  const [isAutoRenew, setAutoRenew] = useState(true);
  useEffect(() => {
    if (initialData && initialData.recurrenceFrequency) {
      setDateType(initialData.dateType || 'ongoing');
      setStartDate(initialData.recurrenceStartDate || null);
      setRecurrenceFrequency(initialData.recurrenceFrequency || 'daily');
      setRecurrenceCycleCount(initialData.recurrenceCycleCount || '');
      console.log(initialData.isAutoRenew);

      setAutoRenew(initialData.isAutoRenew);
    }
  }, [initialData]);

  // Update formData on changes
  useEffect(() => {
    const updatedFormData = {
      recurrenceFrequency,
      dateType,
      isAutoRenew: isAutoRenew, // preserve this since it's updated elsewhere
      recurrenceStartDate: startDate
    };

    if (dateType === 'cycles') {
      updatedFormData.recurrenceCycleCount = recurrenceCycleCount;
    }

    setFormData((prev) => ({
      ...prev,
      ...updatedFormData
    }));
  }, [recurrenceFrequency, startDate, dateType, setFormData, recurrenceCycleCount, isAutoRenew]);

  const handleDateChange = (type, value) => {
    if (type === 'startDate') {
      setStartDate(value);
      setErrors({
        ...errors,
        recurrenceStartDate: ''
      });
    }
  };

  return (
    <>
      {showleftPart ? (
        <>
          <div className="row">
            <div className="col-lg-12">
              <div className="form-control form-control-padd form-control-padd2 ">
                <div className="row align-items-center estimated-value">
                  <div className="col label-title text-left">Start & End Dates</div>
                  <div className="col price-for-project">
                    <Select
                      className="select-days"
                      options={dateTypes}
                      value={dateTypes.find((x) => x.value === dateType) || null}
                      onChange={(selected) => {
                        setDateType(selected.value);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div
                className={`form-control form-control-padd form-control-padd2 ${
                  errors.recurrenceFrequency ? 'form-invalid' : ''
                }`}>
                <div className="row align-items-center estimated-value ">
                  <div className="col label-title text-left">Recurrence Frequency</div>
                  <div className="col price-for-project">
                    <div className="form-group mb-0">
                      <Select
                        className="select-days"
                        options={frequencyOptions}
                        value={frequencyOptions.find((x) => x.value === recurrenceFrequency) || null}
                        onChange={(selected) => {
                          setRecurrenceFrequency(selected.value);
                        }}
                        isDisabled={isEditing}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="row">
            <div className="col-lg-12">
              <div
                className={` radio_btn_section br-10 px-4 ${errors.recurrenceStartDate ? 'form-invalid ' : ''} ${
                  dateType === 'cycles' ? 'mbottom-5' : ''
                }`}>
                <div className=" align-items-center radio_inner_sec">
                  <div className="col label-title text-left pl-0">
                    {' '}
                    <label htmlFor="startDate" className="label-title">
                      Start From
                    </label>
                  </div>
                  <div className="col price-for-project">
                    <DatePicker
                      selected={startDate}
                      onChange={(date) => handleDateChange('startDate', date)}
                      placeholderText="+ Select Date"
                      dateFormat={getDateFormat(store.currentDateFormat)}
                      minDate={new Date()}
                      onKeyDown={(e) => e.preventDefault()}
                      className="datepicker-days border-0"
                      disabled={projectIdFromParams ? isFutureDate(startDate) : false}
                      popperPlacement="top-start"
                      popperProps={{
                        strategy: 'fixed'
                      }}
                    />
                  </div>
                </div>
              </div>
              {errors.recurrenceStartDate && <div className="error-message mb-3 ">{errors.recurrenceStartDate}</div>}
            </div>
            {dateType === 'cycles' && (
              <div className="col-lg-12">
                <div
                  className={`form-control form-control-padd form-control-padd2 mb-15 ${
                    errors.recurrenceCycleCount ? 'form-invalid' : ''
                  }`}>
                  <div className="row align-items-center estimated-value">
                    <div className="col label-title text-left">Cycle Count (max 30)</div>
                    <div className="col price-for-project">
                      <input
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        min="1"
                        max="30"
                        className="project-price"
                        value={recurrenceCycleCount}
                        onChange={(e) => {
                          const val = parseInt(e.target.value.replace(/\D/g, ''), 10); // Remove non-digits
                          setRecurrenceCycleCount(isNaN(val) ? '' : Math.min(30, Math.max(1, val)));
                          setErrors({ ...errors, recurrenceCycleCount: '' });
                        }}
                        placeholder="Enter number of cycles"
                      />
                    </div>
                  </div>
                </div>
                {errors.recurrenceCycleCount && <div className="error-message mb-3">{errors.recurrenceCycleCount}</div>}
              </div>
            )}
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className={`form-control form-control-padd form-control-padd2 mb-15`}>
                <div className="row align-items-center estimated-value">
                  <div className="col label-title text-left">Auto-Renewal</div>
                  <div className="col price-for-project">
                    <div className="form-group mb-0">
                      <Select
                        options={[
                          { value: true, label: 'Auto' },
                          { value: false, label: 'Manually' }
                        ]}
                        value={{
                          value: isAutoRenew,
                          label: isAutoRenew ? 'Auto' : 'Manually'
                        }}
                        onChange={(selected) => setAutoRenew(selected.value)}
                        placeholder="Select Option"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default RecurrenceForm;
